import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { SearchX } from 'lucide-react'
import { StatusScreen } from '@/components/common/StatusScreen'
import { useMessages } from '@/i18n'
import { messages } from './messages'

const NotFound = () => {
  const location = useLocation()
  const m = useMessages(messages)

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname)
  }, [location.pathname])

  return (
    <StatusScreen
      icon={SearchX}
      title={m.pageNotFound}
      hint={m.pageNotFoundHint}
      actionLabel={m.backHome}
      actionTo="/"
    />
  )
}

export default NotFound
